import { useState, useEffect } from 'preact/hooks';
import { MOBILE_MAX_WIDTH } from 'utils/breakpoints';

const useResponsive = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth || 0,
    height: window.innerHeight || 0,
  });
  const [initialized, setInitialized] = useState(false);

  const handleSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize);
    setInitialized(true);

    return () => window.removeEventListener('resize', handleSize);
  }, []);

  return {
    ...windowSize,
    isMobile: windowSize.width <= MOBILE_MAX_WIDTH,
    isTablet: windowSize.width > MOBILE_MAX_WIDTH && windowSize.width < 1024,
    initialized,
  };
};

export default useResponsive;
